import React, { useState, useEffect } from 'react'

export function useMobile() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    function handleWindowResize() {
        setIsMobile(window.innerWidth < 768)
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize)
        handleWindowResize()

        return () => window.removeEventListener('resize', handleWindowResize)
    }, [])

    return isMobile
}

export function withMobile(Component) {
    function MobileWrap(props) {
        const mobile = useMobile()

        return <Component {...props} mobile={mobile} />
    }
    MobileWrap.displayName = `withMobile(${Component.displayName})`

    return MobileWrap
}
